import React from 'react';
import { Col, Row } from 'antd';
import InfoImage from '@BUP/assets/Images/Home/info_image.png';
import { useTranslation } from 'react-i18next';
import styles from './info-bup-panel.module.css';

const InfoBupPanel = ({ title }) => {
  const [t] = useTranslation();
  return (
    <div>
      <Row>
        <Col>
          <h3 className={styles.title}>{title}</h3>
        </Col>
      </Row>

      <Row className={styles.container}>
        <Col span={14} className={styles.text_wrapper}>
          <p className={styles.text}>{t('pages.home.introText')}</p>
          {/* <Button shape="round" className={styles.button}>
            VER MÁS
          </Button> */}
        </Col>
        <Col span={10} className={styles.image_wrapper}>
          <img
            src={InfoImage}
            alt={t('pages.home.imgAlt')}
            className={styles.info_image}
          />
        </Col>
      </Row>
    </div>
  );
};

export default InfoBupPanel;
